import React from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { KanjiBackdrop, Mandala, Seal } from './Ornaments';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-19" data-mp="qnjhxlh2lzfw">
      <div className="paper-card relative overflow-hidden rounded-sm border border-brand-gold/55 p-7 text-center shadow-[0_18px_48px_rgba(44,38,32,0.13)] md:p-12" data-id="element-20" data-mp="qmi6vh021cy6">
        <KanjiBackdrop glyphs={['選', '擇', '今', '始', '道']} data-id="element-21" data-mp="hmv34ojurv1y" />
        <Mandala className="absolute -right-20 -top-20 h-64 w-64 opacity-10" color="#A98546" data-id="element-22" data-mp="hlacha0nsw9d" />
        <Mandala className="absolute -bottom-24 -left-24 h-64 w-64 opacity-10" color="#4A6B57" data-id="element-23" data-mp="cnquq04r61co" />
        <div className="relative" data-id="element-24" data-mp="7q8le8mtpk45">
          <h2 className="font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-25" data-mp="271jj0zrnjv4q">
            Hay dos versiones de vos en este momento.
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-26" data-mp="222ydqlxjml9f">
            <p data-id="element-27" data-mp="354luc2ot57c1">
              Una que cierra esta página y la próxima sesión sigue dependiendo
              únicamente de su memoria. Sin un atlas visual que respalde cada
              punto. Sin protocolos clínicos organizados por patología. Sin el
              material técnico que sus pacientes merecen ver mientras están en la
              camilla.
            </p>
            <p className="font-semibold text-brand-forest" data-id="element-28" data-mp="3nubl8epg98yo">
              Y otra que decide que hoy es el día en que su práctica de
              acupuntura cambia para siempre.
            </p>
            <p className="font-display text-xl italic text-brand-goldDark" data-id="element-29" data-mp="3e2fob6z3now1">
              La pregunta no es si podés pagarlo.
              <br data-id="element-30" data-mp="3j0h3hgten428" />
              La pregunta es cuántas sesiones más vas a trabajar sin el sistema
              visual que tu práctica y tus pacientes necesitan.
            </p>
          </div>
          <div className="mx-auto mt-12 max-w-md rounded-sm border-2 border-brand-burgundy bg-brand-paper p-6 shadow-lg" data-id="element-31" data-mp="fei5w36uu3j7">
            <span className="-mt-10 inline-block rounded-sm bg-brand-burgundy px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-32" data-mp="p6tg8kd1f5td">
              ✦ Más elegido
            </span>
            <h3 className="mt-4 font-serif text-lg font-bold text-brand-ink md:text-xl" data-id="element-33" data-mp="b9enp6rhmhx6">
              ATLAS ANCESTRAL DE ACUPUNTURA™
            </h3>
            <p className="mt-3 text-sm text-brand-muted line-through" data-id="element-34" data-mp="6b3bipdpzvbs">
              $95.000 ARS
            </p>
            <p className="font-serif text-4xl font-bold text-brand-burgundy" data-id="element-35" data-mp="1i1rk2ynp5lc">
              $27.990 ARS
            </p>
            <p className="mt-4 text-sm leading-relaxed text-brand-muted" data-id="element-36" data-mp="3snteyul1u44g">
              3 Tomos + 6 Bonos · 118 páginas + material completo. El sistema
              visual de acupuntura clínica más completo en español para
              terapeutas que quieren aplicar con precisión, velocidad y autoridad
              profesional.
            </p>
            <CTAButton fullWidth className="mt-6 py-3.5 text-sm" data-id="element-37" data-mp="1u8vtejou0vpg">
              → QUIERO MI ATLAS ANCESTRAL $27.990
            </CTAButton>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-38" data-mp="1z90b2d1h7wh9">
            <span className="inline-flex items-center gap-1" data-id="element-39" data-mp="287lojts3clb6">
              <LockKeyholeIcon className="h-4 w-4" data-id="element-40" data-mp="2872et0clh388" />
              Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-41" data-mp="1bjflhbati0z0">
              <ZapIcon className="h-4 w-4" data-id="element-42" data-mp="1ghqz7x48gvmi" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-43" data-mp="1kh85utvebyt9">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-44" data-mp="1p8zn2dsnws6q" />
              Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-45" data-mp="sr3c44lqxzfd">
              <CreditCardIcon className="h-4 w-4" data-id="element-46" data-mp="squygahsuq34" />
              Mercado Pago | Tarjeta
            </span>
          </div>
          <div className="mt-8 flex items-start gap-4 rounded-sm border border-brand-gold/40 bg-brand-surfaceLight/55 p-5 text-left text-sm leading-relaxed text-brand-text" data-id="element-47" data-mp="wqc71csiw3ci">
            <Seal characters="附記" className="mt-0.5 text-[11px]" data-id="element-48" data-mp="8qtos69enf0n" />
            <div data-id="element-49" data-mp="ne52adp5d93e">
              <p data-id="element-50" data-mp="neof5fzxx7ak">
                <strong className="text-brand-ink" data-id="element-51" data-mp="nf7s0iaqh5hq">P.D.:</strong> Si tenés dudas,
                escribinos a{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-52" data-mp="ilbsvciqhckz">
                  {SUPPORT_EMAIL}
                </a>
                , a{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href="https://instagram.com/lumen.akasha" data-id="element-53" data-mp="16cqypf9pyc0z">
                  @lumen.akasha
                </a>{' '}
                en Instagram o por WhatsApp al{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href={WHATSAPP_URL} data-id="element-54" data-mp="384x3qmg54b67">
                  {WHATSAPP_LABEL}
                </a>
                . Te respondemos hoy.
              </p>
              <p className="mt-3 italic text-brand-goldDark" data-id="element-55" data-mp="1ip355qm7o2az">
                El precio de lanzamiento sube pronto. El mejor momento para tener
                tu sistema visual de acupuntura clínica es ahora.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}